import React from "react";
import "./Incrementor.scss";
import { Form } from "antd";

export default function Incrementor({
    initialValue = 1,
    index,
    maxQuantity,
    disabled,
    onIncrement,
    onDecrement,
    keyProp
}) {

    return (
        <div className="outlinedIncrementor">
            <div
                className={disabled ? "disabled" : ""}
                onClick={onDecrement}
            >-</div>
            <Form.Item
                name={['transactions', keyProp, 'quantity']}
                initialValue={initialValue}
            >
                <input
                    disabled={disabled}
                    min={0}
                    max={maxQuantity}
                    type="number"
                />
            </Form.Item>
            <div
                className={disabled ? "disabled" : ""}
                onClick={onIncrement}
            >+</div>
        </div>
    );
}
